import { Response, apiAbortController } from '@ui/src';
import api from '../../../api/api';
import {
  CreateNotificationTemplate,
  NotificationTemplate,
  NotificationTemplateTypes,
} from '../types';

export const notificationSettingsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getNotificationsTemplates: build.query<
      Response<NotificationTemplate>,
      void
    >({
      query: () => ({
        url: '/v1/notifications-types-templates',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getNotificationsTemplatesTypes: build.query<
      { data: NotificationTemplateTypes[] },
      void
    >({
      query: () => ({
        url: '/v1/notifications-types-templates/types',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createNotificationTemplate: build.mutation<
      { data: NotificationTemplate },
      CreateNotificationTemplate
    >({
      query: (body) => ({
        url: '/v1/notifications-types-templates',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    editTemplate: build.mutation<
      { data: NotificationTemplate },
      { body: CreateNotificationTemplate; id: string }
    >({
      query: (data) => ({
        url: `/v1/notifications-types-templates/${data.id}`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetNotificationsTemplatesQuery,
  useCreateNotificationTemplateMutation,
  useEditTemplateMutation,
  useLazyGetNotificationsTemplatesTypesQuery,
} = notificationSettingsApi;

export const {
  endpoints: {
    getNotificationsTemplates,
    createNotificationTemplate,
    editTemplate,
  },
} = notificationSettingsApi;
